import { type Action } from "redux";
import { type ThunkAction } from "redux-thunk";
import { history } from "../_Bootstrap/RoutingAndStore";
import { type RootState } from "../Reducers/DeveloperReducers";

export const UPDATE_USER = "UPDATE_USER";

export type UserType = {
    uuid: string;
    username: string;
    email: string;
    name: string;
    partner_status: "not-registered" | "registered" | "approved";
    can_embed: boolean;
    created_at: string;
    updated_at: string;
    deleted_at: string;
};

interface UpdateUserAction {
    type: typeof UPDATE_USER;
    user: UserType | false;
}

export type UserActionTypes = UpdateUserAction;

export function updateUser(user: UserType | false): UserActionTypes {
    return {
        type: UPDATE_USER,
        user,
    };
}

export function updateUserDetails(details: Partial<UserType>): ThunkAction<void, RootState, unknown, UpdateUserAction> {
    return (dispatch, getState): void => {
        const { user } = getState();

        if(typeof user.user === "boolean") {
            return;
        }

        dispatch({
            type: UPDATE_USER,
            user: {
                ...user.user,
                ...details,
            },
        });
    };
}

export function logoutUser(): ThunkAction<void, RootState, unknown, Action<string>> {
    return (dispatch, getState): void => {
        const { user } = getState();

        dispatch(updateUser(false));

        // Get the current user details
        fetch("/logout", {
            method     : "POST",
            credentials: "same-origin",
            headers    : new Headers({
                "Accept": "application/json",
            }),
        })
            .then((response) => {
                if(response.status !== 200) {
                    throw new Error("Failed to Sign Out");
                }

                return response.json();
            })
            .then(() => {
                dispatch(updateUser(false));
            })
            .catch(err => {
                console.error("API Documentation: Failed to Sign Out user", err);
                dispatch(updateUser(user.user));
            })
            .then(() => {
                history.push("/");
            });
    };
}
